<template>
  <div>
    <v-btn color="grey" top left absolute="" style="left: 60px" disabled text>
      <v-icon style="padding-left: 0% !important; padding-right: 10% !important"
        >mdi-arrow-left-thick</v-icon
      >
      {{ $t(`message.slideNineScriptTextBtnPartOne`) }} <br />
      {{ $t(`message.slideNineScriptTextBtnPartTwo`) }}
    </v-btn>
    <v-navigation-drawer left absolute width="760" :mini-variant="miniVariant">
      <v-list dense nav class="py-0">
        <v-list-item two-line :class="true && 'px-0'">
          <v-list-item-avatar>
            <v-app-bar-nav-icon
              @click.stop="miniVariant = !miniVariant"
            ></v-app-bar-nav-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <p class="text-left" style="font-size: x-large;">
              {{ $t(`message.slideNineScriptTextPartOne`) }}
              <br />
              <br />
              {{ $t(`message.slideNineScriptTextPartTwo`) }}
            </p>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      miniVariant: true
    };
  }
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--disabled {
  color: black !important;
}
.theme--light.v-btn.v-btn--disabled .v-icon,
.theme--light.v-btn.v-btn--disabled {
  color: black !important;
}
</style>
